import { z } from "zod";
import { isValidDate } from "../../../../../../../../../../../../../utils/dateValidate";
import { isValidTime, isGreaterThanTime } from "../../../../../../../../../../../../../utils/timeValidate";

export const schema = z
  .object({
    setor: z.string().min(1, { message: "Setor é obrigatório" }),
    fila: z.string().min(1, { message: "Fila é obrigatória" }),
    servico: z.string().min(1, { message: "Serviço é obrigatório" }),
    data: z.string().min(10, { message: "Data é obrigatória" }),
    tempo: z.string().min(1, { message: "Tempo de atendimento é obrigatório" }),
    horario_especial: z.boolean().default(false),
    hora_inicio: z.string().nullable(),
    hora_fim: z.string().nullable(),
    intervalo_hora_inicio: z.string().nullable(),
    intervalo_hora_fim: z.string().nullable(),
  }).superRefine((data, ctx) => {
    if (!isValidDate(data.data)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Data inválida",
        path: ["data"],
      });
    }

    if (data.horario_especial) {
      if (data.hora_inicio.length < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hora de início é obrigatória",
          path: ["hora_inicio"],
        });
      } else {
        if (!isValidTime(data.hora_inicio)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Hora de início deve ser válida",
            path: ["hora_inicio"],
          });
        }
      }

      if (data.hora_fim.length < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hora de fim é obrigatória",
          path: ["hora_fim"],
        });
      } else {
        if (!isValidTime(data.hora_fim)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Hora de fim deve ser válida",
            path: ["hora_fim"],
          });
        }
      }

      if (!isGreaterThanTime(data.hora_fim, data.hora_inicio)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hora de fim deve ser maior que a hora de início",
          path: ["hora_fim"],
        });
      }

      if (data.intervalo_hora_inicio.length < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hora de início do intervalo é obrigatória",
          path: ["intervalo_hora_inicio"],
        });
      } else {
        if (!isValidTime(data.intervalo_hora_inicio)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Hora de início do intervalo deve ser válida",
            path: ["intervalo_hora_inicio"],
          });
        }
      }

      if (data.intervalo_hora_fim.length < 5) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hora de fim do intervalo é obrigatória",
          path: ["intervalo_hora_fim"],
        });
      } else {
        if (!isValidTime(data.intervalo_hora_fim)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Hora de fim do intervalo deve ser válida",
            path: ["intervalo_hora_fim"],
          });
        }
      }

      if (!isGreaterThanTime(data.intervalo_hora_fim, data.intervalo_hora_inicio)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hora de fim do intervalo deve ser maior que a hora de início do intervalo",
          path: ["intervalo_hora_fim"],
        });
      }
    }
  });
